import getInstanceAxios from "../Request";

const baseDomain = process.env.REACT_APP_TRACKING;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
